import React, { useEffect, useState } from "react";
import { Card, Box, CardContent } from "@mui/material";
import { toast } from "react-toastify";
import BasicTable from "../../components/table/BasicTable";
import { ADMIN_MODULE_ASSIGN_ROLE } from "../../columns/admin-columns";
import {
  getAllRoleList,
  getAssignedRoleList,
} from "../../services/dataService";
import EditModalDialog from "../../components/EditModalDialog";
import { editRoleForm } from "../../schema/form";
import { allowedRolesToAssign } from "../../helpers/adminHelpers";
import { getUser } from "../../services/authService";
import { updateUserRole } from "../../services/dataService";
import {
  ImpexAdmin,
  ImpexFinance,
  ImpexOperations,
  SupplierAdmin,
  SupplierFinance,
  SupplierOperations,
} from "../../global-const/permissionName";

const AssignRole = () => {
  const [mappedData, setMappedData] = useState([]);
  const [open, setOpen] = useState(null);
  const [roleMaster, setRoleMaster] = useState([]);
  const user = getUser();

  useEffect(() => {
    async function mappedUserList() {
      try {
        const response = await getAssignedRoleList();
        setMappedData(response.data);
      } catch (error) {
        toast.error("User Not found");
      }
    }
    mappedUserList();
  }, []);

  const handleUpdate = (data) => {
    setOpen(data);
    console.log(data.RoleName);
    async function getRoles() {
      const response = await getAllRoleList();
      if ([ImpexAdmin, ImpexOperations, ImpexFinance].includes(data.RoleName)) {
        setRoleMaster(
          allowedRolesToAssign(response.data, "impex", true)
        );
      } else if (
        [SupplierAdmin, SupplierFinance, SupplierOperations].includes(
          data.RoleName
        )
      ) {
        setRoleMaster(
          allowedRolesToAssign(response.data, "supplier", true)
        );
      }
    }
    getRoles();
  };

  const handleSubmit = async (data) => {
    const editRolePayload = new FormData();
    try {
      editRolePayload.append("RoletoUserMappingId", data.RoletoUserMappingId);
      editRolePayload.append("ProjectId", 1);
      editRolePayload.append("RoleId", data.role.RoleId);
      editRolePayload.append("UserId", data.UserId);
      editRolePayload.append("Modified_By", user?.userDetails["UserId"]);

      await updateUserRole(editRolePayload);
      setMappedData(
        mappedData.map((item) => {
          if (item.RoletoUserMappingId === data.RoletoUserMappingId) {
            return {
              ...item,
              RoleName: data.role.RoleName,
            };
          }
          return item;
        })
      );
      setOpen(null);
      toast.success("User permission has been updated");
    } catch (error) {
      setOpen(null);
      toast.success("User permission has been updated");
    }
  };

  const handleClose = () => {
    setOpen(null);
  };

  const getPermissionColumn = () => {
    if (user?.isSystemAdmin || user?.isSupplierAdmin) {
      return [
        ...ADMIN_MODULE_ASSIGN_ROLE,
        {
          Header: "EDIT ROLE",
          accessor: "update",
          show: true,
        },
      ];
    } else {
      return ADMIN_MODULE_ASSIGN_ROLE;
    }
  };

  return (
    <>
      <EditModalDialog
        updateModal={open}
        handleClose={handleClose}
        dialogTitle="Update user"
        formSchema={editRoleForm}
        roleMaster={roleMaster}
        onEdit={handleSubmit}
      />
      <Box>
        <Card>
          <CardContent>
            <BasicTable
              columns={getPermissionColumn()}
              data={mappedData}
              onUpdate={handleUpdate}
              pagination
              tableFilter
            />
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default AssignRole;
